// extracted by mini-css-extract-plugin
module.exports = {"quizCard":"styles_quizCard__E9-qO","quizAnswers":"styles_quizAnswers__ixmjU","button":"styles_button__2KQSI"};